import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MedicoService } from './../../shared/servicio/medico/medico.service';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
/// <reference types="google.maps" />

@Component({
  selector: 'app-sucursales',
  templateUrl: './sucursales.component.html',
  styleUrls: ['./sucursales.component.css']
})
export class SucursalesComponent implements OnInit {
  sucursales: any[] = [];
  isLoading = false;
  mostrarMapa = false;
  @ViewChild('mapModal') mapModal!: TemplateRef<any>;
  @ViewChild('mapSucursalModal') mapSucursalModal!: TemplateRef<any>;
  modalRef!: BsModalRef;
  // Valores de ejemplo, podrías obtenerlos dinámicamente
  latitud;
  longitud;
  rangoKm = 5;

  map: google.maps.Map;
  mapSucursal: google.maps.Map;


  sucursalSeleccionada: any = null;
  mostrarMapaSucursal = false;

  constructor(
    private sucursalService: MedicoService,
    private router: Router,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.latitud = position.coords.latitude;
          this.longitud = position.coords.longitude;
          console.log('Ubicación por navegador:', this.latitud, this.longitud);

          this.getUbicacionYBuscarSucursales(); // solo cuando ya tienes coordenadas válidas
        },
        (error) => {
          console.warn('Fallo navegador, usando API de Google:', error);
          this.getUbicacionDelUsuario(() => {
            this.getUbicacionYBuscarSucursales(); // fallback
          });
        }
      );
    } else {
      console.warn('Geolocation no disponible, usando Google API...');
      this.getUbicacionDelUsuario(() => {
        this.getUbicacionYBuscarSucursales();
      });
    }
  }



  loadNearbyBranches(callback?: () => void): void {
    this.sucursalService.getSucursalesCercanas(this.latitud, this.longitud, this.rangoKm).subscribe({
      next: (res: any) => {
        const todas = res.sucursales || res;

        this.sucursales = todas
          .map((s: any) => {
            const distancia = this.calcularDistancia(this.latitud, this.longitud, s.latitud, s.longitud);
            return { ...s, distancia };
          })
          .filter(s => s.distancia <= this.rangoKm)
          .sort((a, b) => a.distancia - b.distancia)
          .map(s => this.formatSucursal(s));

        this.isLoading = false;
        if (callback) callback(); // <-- llamada segura al callback
      },
      error: (err) => {
        console.error('Error al cargar sucursales', err);
        this.isLoading = false;
      }
    });
  }

  formatSucursales(sucursales: any[]): any[] {
    return sucursales.map(sucursal => {
      return {
        nombre: sucursal.sucursal || `Sucursal ${sucursal.codigosuc || ''}`,
        direccion: sucursal.direccion || '',
        distancia: sucursal.distancia || 0,
        latitud: sucursal.latitud || 0,
        longitud: sucursal.longitud || 0,
        codigo: sucursal.codigosuc || '',
        imagen: sucursal.image || '',
        googleMapsUrl: sucursal.google_maps_url || '',
        openStreetMapUrl: sucursal.openstreetmap_url || ''
      };
    }).sort((a, b) => a.distancia - b.distancia);
  }

  verTodasEnMapa(): void {
    this.getUbicacionYBuscarSucursales(() => {
      this.mostrarMapa = true;
      this.modalRef = this.modalService.show(this.mapModal, {
        class: 'modal-xl modal-dialog-centered',
        ignoreBackdropClick: true
      });
      setTimeout(() => this.inicializarMapa(), 300);
    });
  }



  getUbicacionYBuscarSucursales(callback?: () => void): void {
    this.isLoading = true;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.latitud = position.coords.latitude;
          this.longitud = position.coords.longitude;

          this.loadNearbyBranches(() => {
            if (callback) callback();
          });
        },
        (error) => {
          console.error('Error al obtener ubicación', error);
          alert('No se pudo obtener tu ubicación actual.');
          this.isLoading = false;
        }
      );
    } else {
      alert('Tu navegador no soporta geolocalización.');
      this.isLoading = false;
    }
  }

  actualizarRango(): void {
    this.getUbicacionYBuscarSucursales(() => {
      if (this.mostrarMapa) {
        setTimeout(() => this.inicializarMapa(), 100);
      }
    });
  }


  private calcularDistancia(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // Radio de la tierra en km
    const dLat = this.gradosARadianes(lat2 - lat1);
    const dLon = this.gradosARadianes(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.gradosARadianes(lat1)) * Math.cos(this.gradosARadianes(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  private gradosARadianes(grados: number): number {
    return grados * (Math.PI / 180);
  }

  private formatSucursal(sucursal: any): any {
    return {
      nombre: sucursal.sucursal || `Sucursal ${sucursal.codigosuc || ''}`,
      direccion: sucursal.direccion || '',
      distancia: sucursal.distancia || 0,
      latitud: sucursal.latitud || 0,
      longitud: sucursal.longitud || 0,
      codigo: sucursal.codigosuc || '',
      imagen: sucursal.image || '',
      googleMapsUrl: sucursal.google_maps_url || '',
      openStreetMapUrl: sucursal.openstreetmap_url || ''
    };
  }

  verEnMapa(sucursal: any): void {
    this.sucursalSeleccionada = sucursal;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.latitud = position.coords.latitude;
          this.longitud = position.coords.longitude;
          this.mostrarMapaSucursal = true;

          this.modalRef = this.modalService.show(this.mapSucursalModal, {
            class: 'modal-xl modal-dialog-centered',
            ignoreBackdropClick: true
          });

          setTimeout(() => this.inicializarMapaSucursal(), 300);
        },
        (error) => {
          console.error('Error obteniendo ubicación actual', error);
          alert('No se pudo obtener tu ubicación actual.');
        }
      );
    } else {
      alert('Tu navegador no soporta geolocalización.');
    }
  }

  getUbicacionDelUsuario(callback?: () => void): void {
    this.isLoading = true;

    const API_KEY = 'AIzaSyBnttQrcmcaLKv_ovSy1uklF6gL90afOvM'; // <-- reemplaza esto por tu key válida

    fetch(`https://www.googleapis.com/geolocation/v1/geolocate?key=${API_KEY}`, {
      method: 'POST',
    })
      .then((res) => res.json())
      .then((data) => {
        if (data && data.location) {
          this.latitud = data.location.lat;
          this.longitud = data.location.lng;
          console.log('Ubicación desde Google API:', this.latitud, this.longitud);
          if (callback) callback();
        } else {
          throw new Error('Ubicación no encontrada en respuesta.');
        }
      })
      .catch((error) => {
        console.error('Error al obtener ubicación desde Google API:', error);
        alert('No se pudo obtener tu ubicación actual.');
        this.isLoading = false;
      });
  }




  inicializarMapaSucursal(): void {
    const sucursal = this.sucursalSeleccionada;

    const mapElement = document.getElementById('mapSucursal');
    if (!mapElement) {
      console.warn('mapSucursal no está disponible aún');
      return;
    }

    const mapOptions: google.maps.MapOptions = {
      center: { lat: sucursal.latitud, lng: sucursal.longitud },
      zoom: 16
    };

    this.mapSucursal = new google.maps.Map(mapElement, mapOptions);

    // 🔴 Marcador sucursal
    const sucursalMarker = new google.maps.Marker({
      position: { lat: sucursal.latitud, lng: sucursal.longitud },
      map: this.mapSucursal,
      title: sucursal.nombre,
      icon: {
        url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png'
      }
    });

    const infoWindow = new google.maps.InfoWindow({
      content: `
        <div style="max-width: 250px;">
          <strong>${sucursal.nombre}</strong><br>
          <small>${sucursal.direccion}</small>
        </div>
      `
    });

    sucursalMarker.addListener('click', () => {
      infoWindow.open(this.mapSucursal, sucursalMarker);
    });

    // 🔵 Tu ubicación actual
    const userPosition = { lat: this.latitud, lng: this.longitud };

    new google.maps.Marker({
      position: userPosition,
      map: this.mapSucursal,
      title: 'Tu ubicación actual',
      icon: {
        url: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'
      }
    });

    // 🟢 Círculo del rango
    new google.maps.Circle({
      strokeColor: '#00AA00',
      strokeOpacity: 0.6,
      strokeWeight: 2,
      fillColor: '#00AA00',
      fillOpacity: 0.2,
      map: this.mapSucursal,
      center: userPosition,
      radius: this.rangoKm * 1000
    });
  }


  inicializarMapa(): void {
    const center = { lat: this.latitud, lng: this.longitud };

    const mapOptions: google.maps.MapOptions = {
      center,
      zoom: 14
    };

    this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, mapOptions);

    // 🔵 Marcador del usuario
    new google.maps.Marker({
      position: center,
      map: this.map,
      title: 'Tu ubicación',
      icon: {
        url: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'
      }
    });

    // 🟢 Círculo de rango
    new google.maps.Circle({
      strokeColor: '#00AA00',
      strokeOpacity: 0.6,
      strokeWeight: 2,
      fillColor: '#00AA00',
      fillOpacity: 0.2,
      map: this.map,
      center,
      radius: this.rangoKm * 1000
    });

    // 🔴 Marcadores de sucursales
    this.sucursales.forEach(s => {
      const marker = new google.maps.Marker({
        position: { lat: s.latitud, lng: s.longitud },
        map: this.map,
        title: s.nombre,
        icon: {
          url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png'
        }
      });

      const infoWindow = new google.maps.InfoWindow({
        content: `
          <div style="max-width: 250px;">
            <strong>${s.nombre}</strong><br>
            <small>${s.direccion}</small><br>
            <span>Distancia: ${s.distancia.toFixed(2)} km</span>
          </div>
        `
      });

      marker.addListener('click', () => {
        infoWindow.open(this.map, marker);
      });
    });
  }


  goBack(): void {
    // Función para el botón de retroceso
    this.router.navigate(['/ruta-anterior']);
  }
}
